<template>
  <div
    class="modal fade createNewModal"
    id="AddPoidsModal"
    tabindex="-1"
    ref="addPoidsModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="poidsForm" @submit="addPoids" :validation-schema="poidsSchema">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Poids minimal <span class="text-danger">*</span>
                  </label>
                  <Field name="poidsMin" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le poids"/>
                  <ErrorMessage name="poidsMin" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Poids maximal <span class="text-danger">*</span>
                  </label>
                  <Field name="poidsMax" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le poids"/>
                  <ErrorMessage name="poidsMax" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-12" v-if="btntext != 'Modifier'">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Catégorie <span class="text-danger">*</span>
                </label>
                <Field  name="categories"  v-slot="{ field }" v-model="defaultSelectedCategories">
                  <Multiselect
                    :options="categoriesOptions"
                    :searchable="true"
                    track-by="label"
                    multiple="true"
                    mode="tags"
                    label="label"
                    v-bind = "field"
                    placeholder="Sélectionner la catégorie"
                  />
                </Field>    
                <ErrorMessage name="categories" class="text-danger"/>
                <span class="text-danger" v-if="produitsError">La catégorie est obligatoire</span>
              </div>
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
            {{ btntext }}
            </button>
          </div>
        </Form>
        </div>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../../services/ApiService';
import * as Yup from 'yup';
import { Poids } from '../../../models/Poids';
import { error , success, hideModal } from '../../../utils/utils';
import Multiselect from '@vueform/multiselect'

export default defineComponent({
    name: "AddPoidsModal",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const poidsSchema = Yup.object().shape({
      // categories: Yup.array().required('La catégorie est obligatoire'),
      poidsMin: Yup.number().typeError('Veuillez entrer des nombres').required('Le poids minimal est obligatoire'),
      poidsMax: Yup.number().typeError('Veuillez entrer des nombres').required('Le poids maximal est obligatoire'),
    });

    const marqueOptions = ref([]);
    const poidsForm = ref<Poids | null>(null);
    const addPoidsModalRef = ref<null | HTMLElement>(null);
    // const item = ref({ ...props.item });
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter un poids");
    const btntext = ref('Ajouter');
    const categoriesOptions = ref([]);

    watch(() => props.item, (newValue) => {
      getPoids(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier le poids";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter un poids";
         btntext.value = "Ajouter";
      }
    }
    const defaultSelectedCategories = ref<any[]>([]);
    const produitsError = ref(false); 

    watch(defaultSelectedCategories, () => {
      console.log('name', defaultSelectedCategories.value)
      if(defaultSelectedCategories.value.length > 0){
        produitsError.value = false
      }
      else {
        produitsError.value = true
      }
    })
    const getPoids = async (id: number) => {
      return ApiService.get("/poids/"+id)
      .then(({ data }) => {
        // map data in form
        const donnees = data.data;
        // const categories = donnees.categories;

        // let ids: number[] = [];
        // for (const categorie of categories) {
        //   ids.push(categorie.id); 
        // }
        // categories.value= ids;

        // defaultSelectedCategories.value = categories.value
        for (const key in donnees) {
          poidsForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addPoidsModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    const addPoids = async (values: any, poidsForm) => {
      values = values as Poids;
      if(isUPDATE.value){
        ApiService.put("/poids/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              poidsForm.resetForm();
              hideModal(addPoidsModalRef.value);
              isUPDATE.value=false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        if(defaultSelectedCategories.value.length > 0){
          ApiService.post("/poids",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              poidsForm.resetForm();
              hideModal(addPoidsModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });}else{
          produitsError.value = true
        }
      }
    };

    const fetchCatgories = async () => {
      try {
        const response = await ApiService.get('/categories/nopage');
        const marchandsData = response.data.data;
        categoriesOptions.value = marchandsData.map((categories) => ({
          value: categories.id,
          label: `${categories.name}`,
        }));
      } catch (error) {
        //
      }
    };

    onMounted(() => {
      fetchCatgories();
    });

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return { poidsSchema,
      addPoidsModalRef,
      addPoids,
      poidsForm,
      title,btntext,resetValue,
      marqueOptions, categoriesOptions,
      defaultSelectedCategories,
      produitsError,
    };
  },
});
</script>@/models/Poids